import { useTranslation } from "react-i18next";

import girlCheckingTime from "../../../../assets/girl-checking-time.png";
import { MainContentLayout } from "../../../../layouts/desktop/main-content-layout/main-content-layout";
import { AddGuest } from "./add-guest/add-guest";
import { AddedGuests } from "./added-guests/added-guests";
import styles from "./appointment-content.module.scss";
import { AppointmentForm } from "./appointment-form/appointment-form";

export function AppointmentContent() {
  const { t } = useTranslation();

  return (
    <MainContentLayout>
      <section className={styles.rightSideWrapper}>
        <div className={styles.headerWrapper}>
          <h2>{t("contact-information")}</h2>
          <AddGuest />
        </div>
        <div className={styles.mainWrapper}>
          {/* form */}
          <AppointmentForm />
          {/* added guests */}
          <div className={styles.addedGuestsWrapper}>
            <div className={styles.addedGuests}>
              <AddedGuests />
            </div>
            <div className={styles.girlImageWrapper}>
              <img className={styles.girlImage} src={girlCheckingTime} alt="girl checking time" />
            </div>
          </div>
        </div>
      </section>
    </MainContentLayout>
  );
}
